<template>
    <div class='nav-bar'>
        <template v-for="(item, index) in items" >
            <div v-text="item.name" :key="index" class='nav-item' :class="selected_index === index ? 'nav-item-selected' : ''" @click="changeIndexDirect(index)" :data-index="index"></div>
        </template>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            selected_index: 0,
        }
    },
    props: {
        currentIndex: {
            type: Number,
            default: 0,
        },
        items: {
            type: Array,
            default: [],
        }
    },
    computed: {

    },
    watch: {
        currentIndex: function (newValue, oldValue) {
            const len = this.items.length;
            this.selected_index = newValue;
            if (newValue > 1) {
                this.$el.scrollLeft = (newValue - 1) * window.screen.width * 15 / 100;
            } else {
                this.$el.scrollLeft = 0;
            }
        }
    },
    methods: {
        changeIndex: function (event) {
            // dataset返回的均为字符串，如果是一个对象会直接返回对象的toString表示的字符串'[object Object]'；实际index是Number类型
            const index = Number(event.currentTarget.dataset.index);
            this.selected_index = index;
            this.$emit('change-index', index);
        },
        changeIndexDirect: function (index) {
            console.log('changeIndexDirect called: ', index);
            this.selected_index = index;
            this.$emit('change-index', index);
        }
    }
}
</script>

<style scoped>
.nav-bar {
    display: flex;
    justify-content: space-between;
    overflow: auto;
    padding: 6px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    font-size: 20px;
    background-color: #F8F8F8;
    overflow: auto;
}
.nav-item {
    min-width: 50px;
    flex-shrink: 0;
}
.nav-item-selected {
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/NavBarComponent.vue